import { useState } from "react";

type Props = {
  title: string;
};

export default function ShareButtons({ title }: Props) {
  const [copied, setCopied] = useState(false);

  const shareUrl = typeof window !== "undefined" ? window.location.href : "";
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title);

  const weiboHref = `https://ngqwadi.cn/share/share.php?url=${encodedUrl}&title=${encodedTitle}`;
  const qzoneHref = `https://connect.qq.com/widget/shareqq/index.html?url=${encodedUrl}&title=${encodedTitle}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch {
      // clipboard may be unavailable in some environments
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="text-sm font-medium text-foreground-700">分享到</span>
      <button
        type="button"
        onClick={copyLink}
        className="flex items-center gap-2 rounded-md border border-background-300 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
      >
        <i className="ri-wechat-line text-base" />
        微信 / 复制链接
      </button>
      <a
        href={weiboHref}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-2 rounded-md border border-background-300 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
      >
        <i className="ri-weibo-line text-base" />
        微博
      </a>
      <a
        href={qzoneHref}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-2 rounded-md border border-background-300 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
      >
        <i className="ri-qq-line text-base" />
        QQ空间
      </a>
      {copied && (
        <span className="text-xs font-medium text-accent-600">链接已复制</span>
      )}
    </div>
  );
}